/* ================================================== */
/* FLUID EMBED
/* ================================================== */

var $fluidEmbeds, sources;

function updateEmbedSize(element) {
	if (typeof element === 'undefined') {
		$fluidEmbeds.each(function(index, element) { updateEmbedSize(element) });
	} else {
		$(element).find(sources).each(function(index, source) {
			if (!$(source).data('aspect-ratio') && !isNaN(this.height / this.width)) {
				$(source).attr('data-aspect-ratio', this.height / this.width).removeAttr('width height');
			}
		});

		var newWidth = $(element).width();
		$(element).find(sources).each(function(index, source) {
			$(source).width(newWidth).height(newWidth * $(source).data('aspect-ratio'));
		});
	}
}

$(document).ready(function() {
	$fluidEmbeds = $('.fluid-embed');
	sources = 'embed, iframe, object';

	updateEmbedSize();
	$(window).on('resize orientationchange', function() { updateEmbedSize() });
});